export default __webpack_public_path__ + "static/media/69-min.d1f45147.png";